import {v4 as uuidv4} from "uuid";

export function uuidCreate () {
    return uuidv4();
}

export const UUIDEmpty = '00000000-0000-0000-0000-000000000000' as const;

export type UUIDEmpty = typeof UUIDEmpty;